import {ModalPopup} from '@kit';

import React from 'react';

import {LoginForm} from '../login-form';

type Props = {
	onClose: () => void;
};

export const LoginPopup: React.FC<Props> = ({onClose}) => {
	return (
		<ModalPopup open={true} onClose={onClose} maxWidth={520} historyEntry={false}>
			<div className="modal-popup-form">
				<h2>Вход на сайт</h2>
				<p>Для входа на сайта введите логин и пароль.</p>
				<LoginForm onSuccess={onClose} />
			</div>
		</ModalPopup>
	);
};
